import React from 'react'
import CustomLoader from '../../common/loader'

export default function Table({ info,loading }) {

    const tableData = info.data || []
    const headers = Object.keys(tableData).filter(item => item.toLowerCase().includes('carrier')) || []


    const makingTable = (key) => {
        return  tableData[key].map((elem,id) => {
            return (
                <tr key={id}>
                    <td className='table bg-light border-bottom find-route-pd'>{elem.name || "X" }</td>
                    <td className='table bg-light border-bottom find-route-pd'>{elem.holdtime || "X"}</td>
                    <td className='table bg-light border-bottom find-route-pd'>{elem.rate || "X"}</td>
                </tr>    
            )
        })
    }

    const renderTable = () => {
        if (!headers.length) {
            return (
                <div className="col ml-3 mt-3">
                    <div className="dataTables_info " id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return headers.length && headers.map((item) => {
                return (
                    <div className='col'>
                        <div className='text-center bg-dark p-1'>
                            <h4>{item.toLocaleUpperCase()}</h4>
                        </div>
                        {makingTable(item)}
                    </div>
                )

            })
        }

    }

    return (
        <div className="datatable-scroll">
            <div className='row mt-3'>
                {loading ? <CustomLoader /> : renderTable()}
            </div>
        </div>
    )
}
